/**
 * Created by mh on 2017/5/23.
 */
import React, { Component } from 'react';
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';
import JobsViewComponent from './JobsView';
import JobStore from './model/JobStore';

@inject('auth') @observer
export default class Jobs extends Component {
    componentDidMount = () => {
        this.jobsStore.fetch();
        // this.jobsStore.syncUpdate();
    };
    componentWillUnmount = () => {
        // this.jobsStore.unsyncUpdates();
    };

    @observable jobsStore = JobStore.fromJS(this.props.auth, []);


    render() {
        // TODO Move this to TESTs
        // const testJob = new Job();
        // testJob.id = '12345';
        // testJob.type = 'Test Job';
        // testJob.name = 'Test Title';
        // testJob.status = 'running';
        // testJob.progress = '76';
        // testJob.priority = 'normal';
        // testJob.instance = 'SRV-2';


        return (
            <section>
                <h1>Active Jobs</h1>
                <div className="table-responsive">
                    <table className="table table-sm table-striped table-delivermedia">
                        <thead>
                            <tr>
                                <th>Job Type</th>
                                <th>Name</th>
                                <th>Instance</th>
                                <th>Status</th>
                                <th>Priority</th>
                                <th>Progress</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <JobsViewComponent jobs={this.jobsStore.jobs} />
                    </table>
                </div>
            </section>
        );
    }
}
Jobs.wrappedComponent.propTypes = {
    auth: PropTypes.object.isRequired,
};
